import { Model } from '@descomplica/dex-models';

export interface ListInfo {
  id: number;
  weekId: number;
  listId: number;
  classroomId: number;
  isOverdue?: boolean;
  isAnticipated?: boolean;
}

export class ListModel extends Model {
  id: number;

  weekId: number;

  listId: number;

  classroomId: number;

  isOverdue: boolean;

  isAnticipated: boolean;

  constructor(studyPlanningList: ListInfo, getters: any) {
    super(getters);

    this.id = studyPlanningList.id;
    this.weekId = studyPlanningList.weekId;
    this.listId = studyPlanningList.listId;
    this.classroomId = studyPlanningList.classroomId;
    this.isOverdue = studyPlanningList.isOverdue ?? false;
    this.isAnticipated = studyPlanningList.isAnticipated ?? false;
  }
}
